/** The product has a single UI language. */
export const DEFAULT_LOCALE = 'pt-BR' as const;

export type LocaleId = typeof DEFAULT_LOCALE;
